module.exports = __webpack_public_path__ + "img/email-icon.1ce96cf4.svg";